import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    let intervalId = null;
    const display = document.querySelector("#time");
    const startButton = document.querySelector("#timer-start");
    const resetButton = document.querySelector("#timer-reset");

    function startTimer(duration) {
      let timer = duration - 1,
        minutes,
        seconds;
      intervalId = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if (--timer < 0) {
          timer = duration;
          clearInterval(intervalId);
        }
      }, 1000);
    }

    function start() {
      if (intervalId != null) {
        clearInterval(intervalId);
      }

      const durationInSeconds = startButton.dataset.duration;
      startTimer(durationInSeconds);
    }

    function reset() {
      clearInterval(intervalId);
      display.textContent = "00:" + startButton.dataset.duration;
    }

    startButton.addEventListener("click", start);
    resetButton.addEventListener("click", reset);
  }
}
